import { Application } from '@/types/application';
import { Detail } from '@/types/detail';
import { Configuration, Metadata } from '@/types/metadata/metadata';
import { PromptId, PromptList } from '@/types/prompt';
import { ValidationError, ValidationObject } from '@/types/validation';
import { KeyValue } from '@/types/variable';
import { isArray, isNullOrUndefined, isNumber, isObject } from '@/util/typeGuards';
import { valueUtil } from './value';

export const kvValueListUtil = (): ValidationObject<
  KeyValue<PromptList | PromptId | (PromptList | PromptId)[]>[] | undefined
> => {
  const validate = (
    application: Application,
    metadata: Metadata,
    linkedSubroutineId: number,
    nodeId: number,
    blockName: string,
    configuration: Configuration,
    details: Detail
  ): ValidationError[] => {
    const errors: ValidationError[] = [];
    const values = getValue(configuration, details);

    if (!values?.length) {
      if (configuration.required) {
        errors.push({
          severity: 'error',
          message: `Block ${blockName} is missing required values in valuelist ${configuration.label}`,
          id: nodeId
        });
      }
    } else {
      values.map((value) => {
        if (!value.value && !isNumber(value.value)) {
          errors.push({
            severity: 'error',
            message: `Block ${blockName} has an empty value in valuelist ${configuration.label}`,
            id: nodeId
          });
        } else {
          const valueErrors = valueUtil().validate(
            application,
            metadata,
            linkedSubroutineId,
            nodeId,
            blockName,
            configuration,
            value.value as Detail
          );

          if (valueErrors.length) {
            errors.push(...valueErrors);
          }
        }
      });
    }
    return errors;
  };

  const getValue = (
    configuration: Configuration,
    obj: unknown
  ): KeyValue<PromptList | PromptId | (PromptList | PromptId)[]>[] | undefined => {
    if (!obj) return;
    const initVal = obj;
    if (isArray(initVal)) {
      return initVal.map((value) => ({
        key: value.key || '',
        value: isNullOrUndefined(value.value) ? '' : value.value
      }));
    } else if (isObject(obj)) {
      const prop = obj[configuration.value];
      return getValue(configuration, prop);
    }
    return;
  };

  return {
    validate,
    getValue
  };
};
